import { Badge } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { motion } from 'motion/react';
import { use } from 'react';

import CogniteLogo from '#core/assets/cognite-logo-icon.svg?react';
import { ProjectContext } from '#core/contexts/ProjectContext.ts';

import classes from './AtlasAiTitle.module.css';
import { itemTransition } from './transitions.ts';

export interface AtlasAiTitleProps {
  title?: string;
  subtitle?: string;
  disclaimerUrl?: string;
}

/** Hero title component for the Atlas AI chat interface with branding and disclaimer. */
export function AtlasAiTitle({
  title: overrideTitle,
  subtitle = 'Powered by Cognite Atlas AI™',
  disclaimerUrl = '.',
}: AtlasAiTitleProps) {
  const { config } = use(ProjectContext);
  const title = overrideTitle ?? config.feature.ai.agent.name;
  return (
    <motion.div className={classes.title} variants={itemTransition}>
      {title && <div className={classes.titleText}>{title}</div>}

      {disclaimerUrl && (
        <div className={classes.disclaimer}>
          <IconInfoCircle size={16} />
          AI responses may be inaccurate or misleading.
          {/* <Anchor href={disclaimerUrl}>Learn more</Anchor> */}
        </div>
      )}
    </motion.div>
  );
}
